import { useAuth0 } from "@auth0/auth0-react";
import React, { useCallback, useEffect, useState } from "react";

import SettingsIcon from "../../../../Assets/SettingsPages/SettingsIcon.svg";
import Toggle from "../../../../Components/Atoms/Toggle";
import { useSettingsStore } from "../../../../Store/Settings";
import { SettingsPatch } from "../../../../Contracts/Settings";
import DaySelectOptions from "../DaySelectOptions";
import { SettingsPagesChildTabProps } from "../index";

const ConfigureReminderFrequencyTab: React.FC<SettingsPagesChildTabProps> = ({
  currentTabWorkDone
}) => {
  const { isLoading, settings, getSettings, updateSettings } = useSettingsStore();
  const { getAccessTokenSilently } = useAuth0();
  const [dirtySettings, setDirtySettings] = useState<SettingsPatch>({});

  const refreshThings = useCallback(async () => {
    await getSettings(getAccessTokenSilently);
  }, [getAccessTokenSilently, getSettings]);
  useEffect(() => {
    refreshThings();
  }, [refreshThings]);
  const saveAndContinue = async () => {
    if (Object.keys(dirtySettings).length > 0) {
      const success = await updateSettings(getAccessTokenSilently, dirtySettings);
      if (!success) {
        setDirtySettings({});
        return;
      }
    }
    setDirtySettings({});
    currentTabWorkDone();
  };

  const updatedSettings = { ...settings, ...dirtySettings };

  const isDirty = dirtySettings ? Object.keys(dirtySettings).length > 0 : false;

  return (
    <div
      className={`flex flex-col justify-between h-[calc(100vh-13rem)] ${
        isLoading ? "cursor-progress" : ""
      }`}
    >
      <div className="md:w-2/5">
        <div className="flex mt-8">
          <img src={SettingsIcon} alt="Reminder Frequency" />
          <div className="font-semibold text-gray-9 text-m ml-2">Configure Reminder Frequency</div>
        </div>
        <div className="text-gray-800 mt-2 ml-8">
          Configure the frequency of all email reminders sent to client who have not completed the
          payment
        </div>

        <div className="ml-8">
          <div className="mt-8">
            <div className="flex items-center mb-1">
              <div className="font-semibold mb-1">Upcoming due-date</div>
              <Toggle
                checked={updatedSettings.email_upcoming_due_date_enabled || false}
                isLoading={isLoading}
                onChange={enabled =>
                  setDirtySettings({
                    ...dirtySettings,
                    email_upcoming_due_date_enabled: enabled
                  })
                }
                className="ml-2"
              />
            </div>
            <div className="mb-4">
              Email reminder for upcoming payment will be sent to the recipient
            </div>

            <div className="md:flex mb-4">
              <div className="flex">
                <div className="mt-1 mr-2">1st Reminder</div>
                <select
                  className="px-3 mr-2 py-1 border border-gray-5 rounded w-30"
                  value={updatedSettings.email_days_to_send_first_reminder_before_due_date}
                  onChange={e => {
                    setDirtySettings({
                      ...dirtySettings,
                      email_days_to_send_first_reminder_before_due_date: parseInt(e.target.value)
                    });
                  }}
                >
                  <DaySelectOptions />
                </select>
              </div>
              <div className="mt-1">before the due date</div>
            </div>

            <div className="md:flex mb-8">
              <div className="flex">
                <div className="mt-1 mr-2">Repeat every</div>
                <select
                  name="email_days_to_repeat_until_due_date"
                  className="px-3 mr-2 py-1 border border-gray-5 rounded w-30"
                  value={updatedSettings.email_days_to_repeat_until_due_date}
                  onChange={e =>
                    setDirtySettings({
                      ...dirtySettings,
                      email_days_to_repeat_until_due_date: parseInt(e.target.value)
                    })
                  }
                >
                  <DaySelectOptions />
                </select>
              </div>
              <div className="mt-1">until due date</div>
            </div>

            <div className="flex items-center mb-1">
              <div className="font-semibold mb-1">Overdue payments</div>
              <Toggle
                checked={updatedSettings.email_overdue_payments_enabled || false}
                onChange={enabled =>
                  setDirtySettings({
                    ...dirtySettings,
                    email_overdue_payments_enabled: enabled
                  })
                }
                className="ml-2"
              />
            </div>
            <div className="mb-4">
              Weekly email reminders will be sent to the recipients for overdue payment until the
              payment is done.
            </div>
          </div>
        </div>
      </div>
      <footer className="items-end w-full border-gray-200 border-t pt-4 pl-2">
        <button
          className="bg-blue-500  text-white px-4 py-2 rounded hover:bg-blue-700"
          onClick={saveAndContinue}
        >
          {isDirty ? "Save And Continue" : "Next"}
        </button>
        {isDirty && (
          <button
            className="hover:text-red-600 text-gray-500 px-4 py-2 ml-2"
            onClick={() => setDirtySettings({})}
          >
            Discard
          </button>
        )}
      </footer>
    </div>
  );
};

export default ConfigureReminderFrequencyTab;
